import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
    { path: "/", redirect: "/TransferPage" },
    {
        //项目入口首页
        path: "/Home",
        name: "Home",
        component: () => import("@/views/home/Index.vue")
    },
    {
        //登录页
        path: "/Login",
        name: "Login",
        component: () => import("@/views/login/Login.vue")
    },
    {
        //token 失效中转页
        path: "/loginInvalid",
        name: "loginInvalid",
        component: () => import("@/views/login-invalid/Index.vue")
    },
    {
        //人机互演的首页
        path: "/umi",
        name: "umiIndex",
        component: () => import("@/views/training-center/umi/Index.vue")
    },
    {
        //项目中转页
        path: "/TransferPage",
        name: "TransferPage",
        component: () => import("../views/login/IntegratedLogin.vue")
    },
    {
        //项目登录完成首页
        path: "/ProjectHome",
        name: "ProjectHome",
        component: () => import("@/views/project-home/Index.vue")
    },
    {
        //股票测试页面
        path: "/Shares",
        name: "Shares",
        component: () => import("@/views/test/Shares.vue")
    }, //实验报告
    {
        path: "/Report",
        name: "Report",
        component: () => import("@/views/project-home/ReportBig.vue")
    },
    {
        //加载页面
        path: "/Loading",
        name: "Loading",
        component: () => import("@/views/login/Loading.vue")
    },
    {
        //步骤一
        path: "/Step1",
        name: "Step1",
        component: () => import("@/views/specific-page/step1/Index.vue")
    },
    {
        //步骤一
        path: "/Step2",
        name: "Step2",
        component: () => import("@/views/specific-page/step2/Controller.vue")
    },
    {
        //步骤一
        path: "/DataResults",
        name: "DataResults",
        component: () => import("@/views/specific-page/step2/DataResults.vue")
    },
    {
        //步骤二控制器
        path: "/Controller",
        name: "Controller",
        component: () => import("@/views/specific-page/step1/Controller.vue")
    },
    {
        //步骤三股票价值
        path: "/StockValue",
        name: "StockValue",
        component: () => import("@/views/specific-page/step3/StockValue.vue")
    },
    {
        //步骤三计算股票价值
        path: "/CalcStock",
        name: "CalcStock",
        component: () => import("@/views/specific-page/step3/CalcStock.vue")
    },
    {
        //步骤三计算股票理论价格
        path: "/TheoryPrice",
        name: "TheoryPrice",
        component: () => import("@/views/specific-page/step3/TheoryPrice.vue")
    },
    {
        //步骤四量化选股
        path: "/StockSelect",
        name: "StockSelect",
        component: () => import("@/views/specific-page/step4/StockSelect.vue")
    },
    {
        //步骤四理论价格与实际价格对比
        path: "/Froogle",
        name: "Froogle",
        component: () => import("@/views/specific-page/step4/Froogle.vue")
    },
    {
        //步骤四销售毛利率数据整理
        path: "/GrossMargin",
        name: "GrossMargin",
        component: () => import("@/views/specific-page/step4/GrossMargin.vue")
    },
    {
        //步骤四设定指标范围
        path: "/SetRange",
        name: "SetRange",
        component: () => import("@/views/specific-page/step4/SetRange.vue")
    },
    {
        //步骤四量化选股筛选结果
        path: "/ScreenData",
        name: "ScreenData",
        component: () => import("@/views/specific-page/step4/ScreenData.vue")
    },
    {
        //步骤五配置比例
        path: "/CalcScale",
        name: "CalcScale",
        component: () => import("@/views/specific-page/step5/CalcScale.vue")
    },
    {
        //步骤五填写公式
        path: "/FillInCalc",
        name: "FillInCalc",
        component: () => import("@/views/specific-page/step5/FillInCalc.vue")
    },
    {
        //步骤五绘制有效前沿
        path: "/EffectiveFrontier",
        name: "EffectiveFrontier",
        component: () => import("@/views/specific-page/step5/EffectiveFrontier.vue")
    },
    {
        //步骤六 最优风险组合
        path: "/OptimalRisk",
        name: "OptimalRisk",
        component: () => import("@/views/specific-page/step6/OptimalRisk.vue")
    },
    {
        //步骤六 调整角度
        path: "/AdjustAngle",
        name: "AdjustAngle",
        component: () => import("@/views/specific-page/step6/AdjustAngle.vue")
    },
    {
        //步骤六 风险结果
        path: "/RiskResult",
        name: "RiskResult",
        component: () => import("@/views/specific-page/step6/RiskResult.vue")
    },
    {
        //步骤七 选择风险偏好
        path: "/TestPaper",
        name: "TestPaper",
        component: () => import("@/views/specific-page/step7/TestPaper.vue")
    },
    {
        //步骤七  风险偏好测试结果
        path: "/TestResult",
        name: "TestResult",
        component: () => import("@/views/specific-page/step7/TestResult.vue")
    },
    {
        //步骤八  确定资产组合
        path: "/MakeUp",
        name: "MakeUp",
        component: () => import("@/views/specific-page/step8/MakeUp.vue")
    },
    {
        //步骤八  最优资产配比
        path: "/CombinationRatio",
        name: "CombinationRatio",
        component: () => import("@/views/specific-page/step8/CombinationRatio.vue")
    },
    {
        //步骤九 成分股行情序列数据
        path: "/ValueSequence",
        name: "ValueSequence",
        component: () => import("@/views/specific-page/step9/ValueSequence.vue")
    },
    {
        //步骤九 计算组合序列
        path: "/ComputationSequence",
        name: "ComputationSequence",
        component: () =>
            import("@/views/specific-page/step9/ComputationSequence.vue")
    },
    {
        //步骤九 市场基准差异
        path: "/Difference",
        name: "Difference",
        component: () => import("@/views/specific-page/step9/Difference.vue")
    },
    {
        //步骤十  评价资产组合表现
        path: "/Portfolio",
        name: "Portfolio",
        component: () => import("@/views/specific-page/step10/Portfolio.vue")
    },
    {
        //步骤十二  计算Alpha套利组合价值序列
        path: "/CombinedValue",
        name: "CombinedValue",
        component: () => import("@/views/specific-page/step12/CombinedValue.vue")
    },
    {
        //步骤十二  计算Alpha套利组合价值序列表格
        path: "/Table",
        name: "Table",
        component: () => import("@/views/specific-page/step12/Table.vue")
    },
    {
        //步骤十二  计算Alpha套利组合价值序列问答题
        path: "/Question",
        name: "Question",
        component: () => import("@/views/specific-page/step12/Question.vue")
    },
    {
        //步骤十二  计算Alpha套利组合价值序列问答题
        path: "/ComCharts",
        name: "ComCharts",
        component: () => import("@/views/specific-page/step12/ComCharts.vue")
    },
    {
        //步骤十三  评价Alpha套利组合表现
        path: "/PortfolioPerformance",
        name: "PortfolioPerformance",
        component: () =>
            import("@/views/specific-page/step13/PortfolioPerformance.vue")
    },
    {
        //步骤十三  评价Alpha套利组合表现分析
        path: "/PortfolioPerformance2",
        name: "PortfolioPerformance2",
        component: () =>
            import("@/views/specific-page/step13/PortfolioPerformance2.vue")
    },
    {
        //步骤十一  动态套保比率
        path: "/HedgingRatio",
        name: "HedgingRatio",
        component: () => import("@/views/specific-page/step11/HedgingRatio.vue")
    },
    {
        //步骤十一  动态套保比率计算
        path: "/HedgingScale",
        name: "HedgingScale",
        component: () => import("@/views/specific-page/step11/HedgingScale.vue")
    },
    {
        //步骤十一  动态套保比率图
        path: "/HedgingRatioChart",
        name: "HedgingRatioChart",
        component: () =>
            import("@/views/specific-page/step11/HedgingRatioChart.vue")
    },
    {
        //对接国际级中转页
        path: "/ILabXLogin",
        name: "ILabLogin",
        component: () => import("@/views/common/ILabXLogin.vue")
    }
];

const router = new VueRouter({
    mode: "hash",

    routes
});

export default router;
